<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            Visualizar Avaliação
          </div>
        </v-toolbar>

        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="4">
                <v-text-field
                    v-model="content.tipoAvaliacao.descricao"
                    readonly
                    label="Tipo de Avaliação*"
                    outlined
                    dense
                />
              </v-col>
              <v-col cols="8">
                <v-text-field
                    label="Nome da Avaliação*"
                    v-model="content.nome"
                    outlined
                    readonly
                    dense
                />
              </v-col>
            </v-row>

            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                    label="Descrição da Avaliação*"
                    v-model="content.descricao"
                    outlined
                    dense
                    readonly
                />
              </v-col>
            </v-row>

            <v-data-table
                class="mt-5"
                :headers="headers"
                :items="content.perguntas"
                hide-default-footer
            >

              <template v-slot:[`item.tipoResposta`]="{ item }">
                {{ item.tipoResposta.descricao }}
              </template>

              <template v-slot:[`item.obrigatoriedade`]="{ item }">
                {{ item.obrigatoriedade.descricao }}
              </template>

            </v-data-table>

            <v-row class="d-flex justify-end mt-2 mr-1">
              <span class="text-caption text--secondary">Atualizado por: {{content.alteradoPor}} em {{ content.alteradoEm }}</span>
            </v-row>
          </v-form>
        </div>

        <div class="btn-group text-center mt-7">
          <v-btn color="primary" outlined @click="$emit('onClose')">
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { AvaliacaoFormacao } from '~/commons/classes/avaliacao-formacao';

export default {
  props: new DialogProps(AvaliacaoFormacao),
  data() {
    return {
      headers: [
        { text: 'Pergunta', align: 'center', value: 'pergunta' },
        { text: 'Tipo de Resposta', align: 'center', value: 'tipoResposta' },
        { text: 'Obrigatoriedade', align: 'center', value: 'obrigatoriedade' },
      ],
    };
  },
};
</script>

<style scoped>
.dialog {
  padding: 24px;
}
</style>